import React from 'react'
import { Box, Flex, FlexProps } from '@chakra-ui/core'
import { ErrorMessage } from 'components/ui/Input/ErrorMessage'

export interface SurfaceProps extends FlexProps {
  isDragging?: boolean
  isError?: boolean
  errorMessage?: string | null
}

export const Surface: React.FC<SurfaceProps> = ({
  children,
  isError = false,
  isDragging = false,
  errorMessage,
  ...props
}) => (
  <Flex
    flexDir="column"
    background="white"
    borderRadius="10px"
    boxShadow={
      isError
        ? '0px 0px 0px 3px #EA9999'
        : isDragging
        ? '0px 8px 24px 0px rgba(0, 0, 0, 0.15)'
        : '0px 2px 6px 0px #dcdcdc'
    }
    opacity={isDragging ? 0.95 : 1}
    {...props}
  >
    {children}
    {isError && errorMessage && (
      <Box px="10px">
        <ErrorMessage errorMessage={errorMessage} />
      </Box>
    )}
  </Flex>
)
